import React from "react";
import { Field, ErrorMessage } from "formik";
import { TextField } from "formik-material-ui";
import { Grid, SearchSelect, DatePicker, TextEditor, makeStyles, ChipGroup } from "../../.."; // import PropTypes from 'prop-types';

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      padding: "20px"
    },
    flex: {
      display: "flex",
      "flex-direction": "column",
      "justify-content": "space-between"
    },
    mr30: {
      "margin-right": "30px",
      width: "50%"
    },
    currency: {
      width: "220px"
    },
    estimatedValue: {
      display: "flex",
      "flex-direction": "row",
      "align-items": "center",
      height: "auto"
    }
  };
});

var ComercialTaskForm = function ComercialTaskForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode,
      translation = _ref.translation,
      peopleOfContact = _ref.peopleOfContact,
      errors = _ref.errors,
      touched = _ref.touched;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "subject",
    name: "subject",
    key: "subject",
    label: translation ? translation.inputs.task_subject : "Subject",
    placeholder: translation ? translation.inputs.task_subject : "Subject",
    component: TextField,
    className: classes.mr30,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "type",
    name: "type",
    key: "type",
    label: translation ? translation.selects.task_type.placeholder : "Task type",
    className: classes.mr30,
    component: ChipGroup,
    margin: "normal",
    placeholder: translation ? translation.selects.task_type.placeholder : "Task type",
    value: values.type,
    options: translation ? translation.selects.task_type.items : [{
      value: "call",
      label: "Call"
    }, {
      value: "email",
      label: "Email"
    }, {
      value: "meeting",
      label: "Meeting"
    }, {
      value: "visit",
      label: "Visit"
    }],
    clickable: mode !== "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "person_of_contact",
    name: "person_of_contact",
    key: "person_of_contact",
    label: translation ? translation.selects.task_contact.placeholder : "Contact person",
    className: classes.mr30,
    component: SearchSelect,
    placeholder: translation ? translation.selects.task_contact.placeholder : "Contact person",
    margin: "normal",
    value: values.person_of_contact,
    options: peopleOfContact,
    clickable: mode !== "view",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(ErrorMessage, {
    name: "status"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "status",
    name: "status",
    key: "status",
    label: translation ? translation.selects.task_status.placeholder : "Task type",
    className: classes.mr30,
    component: ChipGroup,
    margin: "normal",
    placeholder: translation ? translation.selects.task_status.placeholder : "Task type",
    value: values.status,
    options: translation ? translation.selects.task_status.items : [{
      value: "pending",
      label: "Pending"
    }, {
      value: "done",
      label: "Done"
    }],
    clickable: mode !== "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "date",
    name: "date",
    key: "date",
    label: translation ? translation.inputs.task_date : "Date",
    className: classes.mr30,
    component: DatePicker,
    time: true,
    format: "DD/MM/YYYY HH:mm",
    value: values.date,
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "opportunity_status",
    name: "opportunity_status",
    key: "opportunity_status",
    label: translation ? translation.selects.task_opportunity_status.placeholder : "Opportunity status",
    className: classes.mr30 // component={SearchSelect}
    ,
    component: ChipGroup,
    margin: "normal",
    value: values.opportunity_status,
    options: translation ? translation.selects.task_opportunity_status.items : [{
      value: "lead",
      label: "Lead"
    }, {
      value: "proposal",
      label: "Proposal"
    }, {
      value: "offer",
      label: "Offer"
    }, {
      value: "hibernate",
      label: "On hold"
    }],
    clickable: mode !== "view"
  }), "*", " "), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6,
    className: classes.details
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "details",
    name: "details",
    key: "details",
    label: translation ? translation.inputs.task_details : "Task details"
  }, function (_ref2) {
    var field = _ref2.field;
    return /*#__PURE__*/React.createElement(TextEditor, {
      value: field.value,
      mode: mode,
      label: translation ? translation.inputs.task_details : "Task details",
      onChange: field.onChange(field.name)
    });
  })));
}; // ComercialTaskForm.propTypes = {
// 	/** Values coming from Formik*/
// 	values: PropTypes.object,
// 	/** Mode to be render. If 'add' content can be added, if 'edit', previous content would be loaded and can be edited, if 'view' no edit option is allowed */
// 	mode: PropTypes.oneOf([ 'edit', 'view', 'add' ])
// };
// ComercialTaskForm.defaultProps = {
// 	mode: 'add'
// };


export { ComercialTaskForm };